// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l-ZU7","colMin":"styles_colMin__fh3eN"};